import { render, staticRenderFns } from "./LvDataTable.vue?vue&type=template&id=fce3763c"
import script from "./LvDataTable.vue?vue&type=script&lang=js"
export * from "./LvDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports